import {h, render} from 'preact';

const Calculations = () => {
 return (
   <div className="service-list">
     <ul className="list">
       <li>Aviation</li>
       <li>Engineering</li>
       <li>Mathematics</li>
       <li>Statistics</li>
       <li>Physics</li>
       <li>Chemistry</li>
       <li>Biology</li>
       <li>Ecology</li>
       <li>Zoology</li>
       <li>Geography</li>
       <li>Astronomy</li>
       <li>Finance</li>
       <li>Accounting</li>
       <li>Management</li>
       <li>Business studies</li>
       <li>Medical science</li>
       <li>Nursing</li>
       <li>Health care</li>
       <li>Architecture, building and planning</li>
       <li>Geology</li>
     </ul>
   </div>
 );
};

export default Calculations;
